import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35f2e51f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "order-details"
};
const _hoisted_2 = { class: "order-details__header" };
const _hoisted_3 = { class: "order-details__info order-details__section" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "order-details__label" };
const _hoisted_6 = { class: "order-details__value" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_8 = { class: "order-details__section" };
const _hoisted_9 = { class: "order-details__section-title" };
const _hoisted_10 = ["src"];
const _hoisted_11 = {
    key: 1,
    class: "order-details__total"
};
const _hoisted_12 = { class: "order-details__total-label" };
const _hoisted_13 = { class: "order-details__total-value" };
const _hoisted_14 = {
    key: 2,
    class: "order-details__empty"
};
const _hoisted_15 = {
    key: 1,
    class: "order-details__loading"
};
import i18n from '@/i18n';
import { computed } from 'vue';
import { formatCurrency, formatLongDate } from '@/utilities/formatters';
import CustomerOrderDetailsSkeleton from '@/components/oto/customerview/components/CustomerOrderDetailsSkeleton.vue';
import CustomerOrderDetailsProductItem from '@/components/oto/customerview/components/CustomerOrderDetailsProductItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerOrderDetails',
    props: {
        loading: { type: Boolean },
        orderDetails: {}
    },
    setup(__props) {
        const props = __props;
        const infoItems = computed(() => {
            if (!props.orderDetails)
                return [];
            return [
                {
                    icon: props.orderDetails.type === 'on' ? 'ShoppingOn' : 'ShoppingOff',
                    label: i18n.global.t('base-management.customer-activity.order-details.purchase-in-store'),
                    value: props.orderDetails.store,
                },
                {
                    icon: 'Cart',
                    label: i18n.global.t('base-management.customer-activity.order-details.quantity-of-products'),
                    value: `${props.orderDetails.products.length} ${i18n.global.tc('base-management.customer-activity.product', props.orderDetails.products.length)}`,
                    showTooltip: !props.orderDetails.products.length,
                },
                {
                    icon: 'Persona',
                    label: i18n.global.t('base-management.customer-activity.order-details.seller'),
                    value: props.orderDetails.sellerName,
                },
                {
                    icon: 'Box',
                    label: i18n.global.t('base-management.customer-activity.order-details.order-number'),
                    value: props.orderDetails.orderId,
                },
                {
                    icon: 'Calendar',
                    label: i18n.global.t('base-management.customer-activity.order-details.date'),
                    value: formatLongDate(props.orderDetails.date),
                },
            ];
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_divider = _resolveComponent("el-divider");
            return (!props.loading && props.orderDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoItems.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: item.label,
                                    class: "order-details__info-item"
                                }, [
                                    _createElementVNode("img", {
                                        src: require(`@/assets/svgs/${item.icon}.svg`)
                                    }, null, 8, _hoisted_4),
                                    _createElementVNode("p", null, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.value), 1)
                                    ]),
                                    (item.showTooltip)
                                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                            key: 0,
                                            content: _ctx.$t('base-management.customer-activity.inconsistencies'),
                                            placement: "bottom",
                                            "popper-class": "customer-activity__tooltip"
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_7
                                            ]),
                                            _: 1
                                        }, 8, ["content"]))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ])
                    ]),
                    _createVNode(_component_el_divider),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h3", _hoisted_9, [
                            _createElementVNode("img", {
                                src: require(`@/assets/svgs/Dolar.svg`)
                            }, null, 8, _hoisted_10),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('base-management.customer-activity.products-purchased')), 1)
                        ]),
                        (_ctx.orderDetails?.products?.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.orderDetails.products, (product) => {
                                return (_openBlock(), _createBlock(CustomerOrderDetailsProductItem, {
                                    key: product.productId,
                                    product: product
                                }, null, 8, ["product"]));
                            }), 128))
                            : _createCommentVNode("", true),
                        (_ctx.orderDetails?.products?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('base-management.customer-activity.total-order')) + ":", 1),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatCurrency)(_ctx.orderDetails.amount)), 1)
                            ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('base-management.customer-activity.no-products-found')), 1))
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(CustomerOrderDetailsSkeleton)
                ]));
        };
    }
});
